export function filterPicture (url) {
  return url && url.indexOf('http') !== 0
    ? 'https://file.dg.vanke.geekclo.com/' + url
    : url 
}

export function filterAvatar (url) {
  return url && url.indexOf('http') !== 0
    ? 'https://file.dg.vanke.geekclo.com/' + url + '?x-oss-process=image/resize,m_fixed,h_62,w_62'
    : url
}

export function filterOriginPicture (url) {
  return url && url.indexOf('http') !== 0
    ? window.location.origin + '/ossfile/' + url
    : url 
}

export function filterTimestamp (timestamp) {
  const date = new Date(timestamp * 1000)

  return date.getFullYear() + '.' + formatNumber(date.getMonth() + 1) + '.' + formatNumber(date.getDate()) + ' ' 
    + formatNumber(date.getHours()) + ':' + formatNumber(date.getMinutes())
}

export function filterTime (time) {
  return time.replace(/-/g, '.')
}

function formatNumber (number) {
  return number.toString().length === 1 ? '0' + number : number
}

export function filterPrice (val) {
  // if (!(val % 100)) return parseInt(val / 100)
  // return (val / 100).toFixed(val % 10 ? 2 : 1)

  return (val / 100).toFixed(2)
}